import { TopLevelSpecification } from '../../../../specification/levels/TopLevelSpecification';
import { CaseProjection } from '../../CaseProjection';

export const getCaseGroundLevel = (
  caseProjection: CaseProjection
): TopLevelSpecification | undefined =>
  caseProjection.projectedTopLevels.find((level) => level.level === 0);
